import { render, staticRenderFns } from "./stepSix.vue?vue&type=template&id=3e61b6e0&"
import script from "./stepSix.vue?vue&type=script&lang=js&"
export * from "./stepSix.vue?vue&type=script&lang=js&"
import style0 from "./stepSix.vue?vue&type=style&index=0&id=3e61b6e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports